// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2nbHJ","author":"Table_author__11fUk","authorImage":"Table_authorImage__7HRGw","unreadRow":"Table_unreadRow__3j5YZ"};